import { useTranslation } from 'react-i18next'

export const GoogleIcon = () => {
  const { t } = useTranslation()

  return (
    <img
      alt={t('google logo')}
      className="h-5 w-5"
      loading="lazy"
      src="https://www.svgrepo.com/show/475656/google-color.svg"
    />
  )
}
